import { render, staticRenderFns } from "./ZurnalasGaunami.vue?vue&type=template&id=bdf707ae&scoped=true&"
import script from "./ZurnalasGaunami.vue?vue&type=script&lang=js&"
export * from "./ZurnalasGaunami.vue?vue&type=script&lang=js&"
import style0 from "./ZurnalasGaunami.vue?vue&type=style&index=0&id=bdf707ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf707ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VContainer,VDataTable,VFooter,VSpacer,VTooltip})
